export const RelationshipCorporateOptions = [
  { value: '', label: '' },
  { label: 'Officer/Authorized Representative', value: 'Officer/Authorized Representative' },
  { label: 'Shareholder', value: 'Shareholder' },
  { label: 'Authorized Signatory', value: 'Authorized Signatory' }
]
